"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const functions_1 = require("@/common/functions");
const styled_1 = __importDefault(require("@emotion/styled"));
const _1 = require(".");
function default_1() {
    const products = (0, react_redux_1.useSelector)((state) => state.productData);
    const perChunk = 4;
    const isScrollable = products.length > perChunk;
    const chunkedProducts = (0, functions_1.chunkArray)(products, perChunk);
    const productsAvailable = Boolean(chunkedProducts.length);
    const { setScrollDiv } = (0, functions_1.useHorizontalDragScroll)(isScrollable);
    const [dialogOpen, setDialogOpen] = (0, react_1.useState)(false);
    const [currentProductId, setCurrentProductId] = (0, react_1.useState)(0);
    const onPhotoClick = (productId) => {
        setCurrentProductId(productId);
        setDialogOpen(true);
    };
    const closeDialog = () => {
        setDialogOpen(false);
        setCurrentProductId(0);
    };
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(ProductsListWrapper, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ id: "title" }, { children: t('메뉴') })), productsAvailable ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ ref: setScrollDiv, className: "horizontal_drag_scroll", id: "products_list" }, { children: chunkedProducts.map((chunk, chunkIdx) => ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "list_slide", css: { width: isScrollable ? '82%' : '100%' } }, { children: chunk.map((product, chunkedProductIndex) => {
                                const productIndex = chunkIdx * perChunk + chunkedProductIndex;
                                return ((0, jsx_runtime_1.jsx)(_1.ProductBar, { product: product, productIndex: productIndex, onPhotoClick: onPhotoClick }, `product_add_bar_${chunkIdx}_${product.id}_${chunkedProductIndex}`));
                            }) }), `chunked_products_${chunkIdx}`))) })), (0, jsx_runtime_1.jsx)(_1.ProductPhotoDialog, { open: dialogOpen, closeDialog: closeDialog, currentProductId: currentProductId })] })) : ((0, jsx_runtime_1.jsx)(_1.ProductsListSkeleton, {}))] }));
}
exports.default = default_1;
const ProductsListWrapper = styled_1.default.div `
  padding: 20px 0;
  margin-bottom: 10px;
  background-color: white;
  #title {
    display: flex;
    align-items: center;
    padding: 0 20px 14px;
    font-weight: bold;
    font-size: 15px;
    svg {
      margin: 0 4px 0 -4px;
    }
  }
  #products_list {
    column-gap: 10px;
    padding: 10px 20px;
    margin: -10px 0;
    .list_slide {
      display: grid;
      align-content: flex-start;
      flex-shrink: 0;
      row-gap: 8px;
      height: auto;
    }
  }
`;
